const PLATFORM_TYPES_ENUM = {
  ADMIN: "admin",
  DELIVERY: "delivery",
  CLIENT: "client",
  CONTRACTOR: "contractor",
};

export default PLATFORM_TYPES_ENUM;
